import React, { useState } from 'react'
import cx from 'classnames'
import { ACCOUNT_PASSWORD_CHANGE } from 'constants/feature-flags'
import PasswordResetOverlayContainer from 'redux/containers/components/account/PasswordResetOverlayContainer'
import PageHeader from 'components/account/PageHeader'

const AccountDetails = ({ details: { name, email, pin, isExternalAuth }, className }) => {
  const [openPasswordResetModal, setOpenPasswordResetModal] = useState(false)
  const handleResetPasswordOnCLick = () => setOpenPasswordResetModal(true)

  return (
    <div className={cx(className, 'flex flex-column f5 lighter account-item-rows')}>
      <PageHeader title='User details' />
      <div className='flex flex-column-t pv6 ph5'>
        <span className='min-w12 f5-t'>Name</span>
        <span className='grow-5 wb-all'>{name}</span>
      </div>
      <div className='flex flex-column-t pv6 ph5'>
        <span className='min-w12 f5-t'>Email</span>
        <span className='grow-5 wb-all'>{email}</span>
      </div>
      <div className='flex flex-column-t pv6 ph5'>
        <span className='min-w12 f5-t'>PIN</span>
        <span className='grow-5 wb-all'>{pin}</span>
      </div>
      {ACCOUNT_PASSWORD_CHANGE && !isExternalAuth && (
        <ResetPasswordButton onClick={handleResetPasswordOnCLick} />
      )}
      <PasswordResetOverlayContainer {...{ openPasswordResetModal, setOpenPasswordResetModal }} />
    </div>
  )
}

const ResetPasswordButton = ({ onClick }) => (
  <div className='tl pt7'>
    <button
      className='bg-teal white pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90 pointer'
      {...{ onClick }}
      data-event-category='Account'
      data-event-action='Reset password'
    >
      Reset password
    </button>
  </div>
)

export default AccountDetails
